var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.217 5.57a4.17 4.17 0 11-8.34 0 4.17 4.17 0 018.34 0zM1.4 21v-4.35a3.765 3.765 0 013.765-3.765h12.004a3.765 3.765 0 013.765 3.765V21"
  }))));
};
export default SvgAccount;